/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewDataleak
 */
export interface CRSFSecReviewDataleak {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    domain: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewDataleak
     */
    features: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    fullname?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    infected_machine_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    infected_path?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewDataleak
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleak
     */
    severity?: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    target_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    target_subdomain?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    target_url?: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleak
     */
    updated: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    user_browser?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    user_hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDataleak
     */
    user_os?: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDataleak
     */
    year?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewDataleak interface.
 */
export function instanceOfCRSFSecReviewDataleak(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "features" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "updated" in value;

    return isInstance;
}

export function CRSFSecReviewDataleakFromJSON(json: any): CRSFSecReviewDataleak {
    return CRSFSecReviewDataleakFromJSONTyped(json, false);
}

export function CRSFSecReviewDataleakFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDataleak {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'domain': json['domain'],
        'features': json['features'],
        'fullname': !exists(json, 'fullname') ? undefined : json['fullname'],
        'infected_machine_id': !exists(json, 'infected_machine_id') ? undefined : json['infected_machine_id'],
        'infected_path': !exists(json, 'infected_path') ? undefined : json['infected_path'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'name': json['name'],
        'severity': !exists(json, 'severity') ? undefined : json['severity'],
        'target_domain': !exists(json, 'target_domain') ? undefined : json['target_domain'],
        'target_subdomain': !exists(json, 'target_subdomain') ? undefined : json['target_subdomain'],
        'target_url': !exists(json, 'target_url') ? undefined : json['target_url'],
        'updated': json['updated'],
        'user': !exists(json, 'user') ? undefined : json['user'],
        'user_browser': !exists(json, 'user_browser') ? undefined : json['user_browser'],
        'user_hostname': !exists(json, 'user_hostname') ? undefined : json['user_hostname'],
        'user_os': !exists(json, 'user_os') ? undefined : json['user_os'],
        'year': !exists(json, 'year') ? undefined : json['year'],
    };
}

export function CRSFSecReviewDataleakToJSON(value?: CRSFSecReviewDataleak | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'domain': value.domain,
        'features': value.features,
        'fullname': value.fullname,
        'infected_machine_id': value.infected_machine_id,
        'infected_path': value.infected_path,
        'ip_addresses': value.ip_addresses,
        'name': value.name,
        'severity': value.severity,
        'target_domain': value.target_domain,
        'target_subdomain': value.target_subdomain,
        'target_url': value.target_url,
        'updated': value.updated,
        'user': value.user,
        'user_browser': value.user_browser,
        'user_hostname': value.user_hostname,
        'user_os': value.user_os,
        'year': value.year,
    };
}

